import { fetch as originalFetch } from 'domain-task';

import { API_BASE_PATH } from '../../../Shared/constants';

export const CONTENT_TYPE_HEADER = 'Content-Type';

const Backend = { fetch: originalFetch };
let { fetch } = Backend;

// Check that a response was ok; throw error if not.
export const checkStatus = response => {
  if (response.ok) {
    return Promise.resolve(response);
  }
  const error = new Error(response.statusText);
  error.response = response;
  return Promise.reject(error);
};

// Set required properties shared across request types.
export const setRequiredProperties = properties => {
  if (!properties.headers) {
    properties.headers = {};
  }

  const requiredProperties = {
    credentials: 'include',
    redirect: 'follow',
  };

  const requiredHeaders = {
    Accept: 'application/json',
  };

  properties.headers = {
    ...properties.headers,
    ...requiredHeaders,
  };

  return {
    ...properties,
    ...requiredProperties,
  };
};

// Ensure API_BASE_PATH is included.
export const getFullUrl = endpoint =>
  endpoint.indexOf(API_BASE_PATH) === -1 ? API_BASE_PATH + endpoint : endpoint;

// Prep API call, fetch a response, and handle it.
export const callApi = (endpoint, properties = {}) => {
  const updatedProperties = setRequiredProperties(properties);
  const url = getFullUrl(endpoint);

  return fetch(url, updatedProperties)
    .then(checkStatus)
    .then(response => response);
};

// Call API and return response as JSON.
export const callApiReturnJson = (endpoint, properties = {}) =>
  callApi(endpoint, properties).then(response => response.json());

// Call API and send body as JSON. Returns full response.
export const callApiSendJson = (endpoint, method, body = {}, properties = {}) => {
  // Set required properties
  properties = {
    ...properties,
    method,
    body: JSON.stringify(body),
    headers: {
      ...properties.headers,
      [CONTENT_TYPE_HEADER]: 'application/json',
    },
  };

  return callApi(endpoint, properties);
};

// Inject backend to facilitate testing.
export const inject = (mockedBackend = Backend) => {
  fetch = mockedBackend.fetch;
};



// WEBPACK FOOTER //
// ./src/Shared/Services/utilities/baseApi.js